/*
 * prepareEntityForForm.tsx - Ausgangsdaten mit Schemadaten aufbereiten.
 *
 * Created by Dr. Maximillian Dornseif 2023-02-27 in hd-kindpages 0.1.0
 * Copyright (c) 2023 HUDORA GmbH
 */

import cleanDeep from 'clean-deep';
import { cleanGqlInput } from 'graphql-clean-diff';
import { JSONSchema7 } from 'json-schema';
import { prepareDataForRjsf } from 'json-schema-prepare-data-for-form';

import { IEntity } from '../../types';

export function prepareEntityForForm(schema: JSONSchema7, inEntity?: Partial<IEntity>) {
  const cleanEntity = cleanDeep(inEntity, {
    emptyStrings: true,
    nullValues: true,
    emptyArrays: false,
    emptyObjects: true,
  });
  const prepared = prepareDataForRjsf(schema, cleanEntity);
  const entity = cleanGqlInput(prepared);
  return { entity, cleanEntity };
}
